export const pirdyAccountContractVersion = 1;
export const pirdyAccountLocalStorage = "DeviceLocal";

const cloudControlStates = new Set([
  "NotActivated", "Trial", "Active", "Grace", "Suspended", "Cancelled", "Expired",
]);
const cloudDataStates = new Set(["NotCreated", "Active", "ReadOnlyRetention", "Purged"]);

export function validatePirdyAccount(value) {
  if (!value || value.contractVersion !== pirdyAccountContractVersion)
    throw new Error("Pirdy returned an unsupported account contract.");
  if (!boundedIdentity(value.accountId) || !cloudControlStates.has(value.cloudControlState) ||
      !cloudDataStates.has(value.cloudDataAvailability))
    throw new Error("Pirdy returned an invalid account projection.");

  const organizationId = optionalIdentity(value.organizationId);
  if (value.organizationId != null && organizationId == null)
    throw new Error("Pirdy returned an invalid organization identity.");
  if (organizationId == null &&
      (value.cloudControlState !== "NotActivated" || value.cloudDataAvailability !== "NotCreated"))
    throw new Error("An account without an organization cannot expose Cloud Control state.");

  const capabilities = value.capabilities;
  const uploadAllowed = organizationId != null &&
    ["Trial", "Active", "Grace"].includes(value.cloudControlState) &&
    value.cloudDataAvailability === "Active";
  if (!capabilities || capabilities.localControlAvailable !== true ||
      capabilities.offlineUnlockAvailableOnTrustedDevice !== true ||
      capabilities.localContentStorage !== pirdyAccountLocalStorage ||
      capabilities.automaticCloudUploadEnabled !== false ||
      capabilities.cloudContentUploadAllowed !== uploadAllowed)
    throw new Error("Pirdy returned account capabilities that cross the Local Control boundary.");

  return { ...value, accountId: value.accountId.trim(), organizationId };
}

function boundedIdentity(value) {
  return typeof value === "string" && value.trim().length > 0 && value.length <= 64 &&
    !/[\u0000-\u001f\u007f]/u.test(value);
}

function optionalIdentity(value) {
  if (value == null) return null;
  return boundedIdentity(value) ? value.trim() : null;
}
